import type { jsPDF } from 'jspdf';
import { RGB } from '../../theme/themes';

export type IconDrawFn = (doc: jsPDF, x: number, y: number, size: number, color: RGB) => void;

/** House outline — households evicted / households at risk. */
export const houseIcon: IconDrawFn = (doc, x, y, size, color) => {
  doc.setDrawColor(color[0], color[1], color[2]);
  doc.setLineWidth(0.9);
  const roofPeakX = x + size / 2;
  const baseY = y + size * 0.42;
  const bottomY = y + size;
  const leftWallX = x + size * 0.14;
  const rightWallX = x + size * 0.86;

  doc.line(x, baseY, roofPeakX, y);
  doc.line(roofPeakX, y, x + size, baseY);
  doc.line(leftWallX, baseY, leftWallX, bottomY);
  doc.line(rightWallX, baseY, rightWallX, bottomY);
  doc.line(leftWallX, bottomY, rightWallX, bottomY);
};

/** House outline with a small heart accent — households reached (prevention/response). */
export const houseSupportIcon: IconDrawFn = (doc, x, y, size, color) => {
  houseIcon(doc, x, y, size, color);
  doc.setFillColor(color[0], color[1], color[2]);
  const cx = x + size / 2;
  const cy = y + size * 0.68;
  const r = size * 0.09;
  doc.circle(cx - r * 0.9, cy, r, 'F');
  doc.circle(cx + r * 0.9, cy, r, 'F');
  doc.triangle(cx - r * 1.8, cy + r * 0.3, cx + r * 1.8, cy + r * 0.3, cx, cy + r * 2.2, 'F');
};

/** Simple person silhouette — individuals affected / reached. */
export const personIcon: IconDrawFn = (doc, x, y, size, color) => {
  doc.setDrawColor(color[0], color[1], color[2]);
  doc.setLineWidth(0.9);
  const cx = x + size / 2;
  const headR = size * 0.17;
  const headCy = y + headR;
  doc.circle(cx, headCy, headR, 'D');
  const shoulderY = headCy + headR + size * 0.1;
  doc.triangle(x + size * 0.12, y + size, x + size * 0.88, y + size, cx, shoulderY, 'D');
};

/** Map pin — districts / locations at risk. */
export const pinIcon: IconDrawFn = (doc, x, y, size, color) => {
  const cx = x + size / 2;
  const r = size * 0.28;
  const cy = y + r;
  doc.setDrawColor(color[0], color[1], color[2]);
  doc.setLineWidth(0.9);
  doc.circle(cx, cy, r, 'D');
  doc.setFillColor(color[0], color[1], color[2]);
  doc.triangle(cx - r * 0.6, cy + r * 0.55, cx + r * 0.6, cy + r * 0.55, cx, y + size, 'F');
};

/** Warning triangle with exclamation mark — extreme/urgent cases. */
export const warningIcon: IconDrawFn = (doc, x, y, size, color) => {
  doc.setDrawColor(color[0], color[1], color[2]);
  doc.setLineWidth(0.9);
  const cx = x + size / 2;
  doc.triangle(x, y + size, x + size, y + size, cx, y, 'D');
  doc.setFillColor(color[0], color[1], color[2]);
  doc.rect(cx - 0.6, y + size * 0.38, 1.2, size * 0.28, 'F');
  doc.circle(cx, y + size * 0.82, 0.9, 'F');
};